import { PropsWithChildren, RefObject, useContext, useEffect, useRef } from 'react';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import styled from 'styled-components';

import UIContext from '~/ui/ui-context';
import { ModalWrapper } from '~/components/modal/modal';
import { calcModalHeight } from '~/utils/layout-utils';

type ModalWrapperStyledProps = {
	small?: boolean;
	hasStaticHeader?: boolean;
	withinSidebar?: boolean;
	customHeight?: string;
	welcomePopup?: boolean;
};

export const ModalMobileStyled = styled(ModalWrapper)<ModalWrapperStyledProps>`
	overflow: scroll;
	transform: translate3d(0, 0, 0);
	-webkit-overflow-scrolling: touch;
	-webkit-transform: translateZ(0);
	height: ${props => calcModalHeight(props)};
	bottom: 0;
	top: unset;

	&::-webkit-scrollbar {
		display: none;
	}
`;

type Props = {
	blurBg: boolean;
	notificationPopup?: boolean;
	show: boolean;
	bodyScrollDisabled: boolean;
};

const ModalMobile = ({
	children,
	blurBg,
	notificationPopup = false,
	show,
	bodyScrollDisabled,
	...rest
}: PropsWithChildren<Props>) => {
	const modalRef: RefObject<HTMLDivElement | null> = useRef(null);

	const { hasStaticHeader, hasHeader, hasProductNav } = useContext(UIContext);

	useEffect(() => {
		if (show && modalRef.current) {
			if (bodyScrollDisabled) {
				disableBodyScroll(modalRef.current);
			} else {
				enableBodyScroll(modalRef.current);
			}
		}
		return () => clearAllBodyScrollLocks();
	}, [modalRef, show, bodyScrollDisabled]);

	if (!show) return null;
	return (
		<ModalMobileStyled
			key="modal-x"
			ref={modalRef}
			blurBg={blurBg}
			notificationPopup={notificationPopup}
			hasStaticHeader={hasStaticHeader}
			hasHeader={hasHeader}
			hasProductNav={hasProductNav}
			{...rest}
		>
			{children}
		</ModalMobileStyled>
	);
};

export default ModalMobile;
